/**
 * This error is intended to be thrown in case of detection of an unsupported timeseries format.
 */
export class TimeseriesFormatError extends Error {
  /**
   * @param msg - that describes the specific timeseries formatting issue.
   */
  constructor(msg: string) {
    super(msg);

    // Set the prototype explicitly.
    Object.setPrototypeOf(this, TimeseriesFormatError.prototype);
  }
}
